exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saved-filter-wrapper .btn-filter{padding-left:.5rem;padding-right:.5rem}.saved-filter-wrapper .saved-filter-item{padding:1rem 2rem!important}.saved-filter-wrapper .saved-filter-item:hover{color:#4466f2}.saved-filter-wrapper .saved-filter-item:focus{background:transparent}.saved-filter-wrapper .saved-filter-item.active{color:#4466f2}.saved-filter-wrapper .saved-filter-dropdown-menu{min-width:378px;margin-top:5px}.saved-filter-wrapper .saved-filter-dropdown-menu .dropdown-search-result-wrapper{max-height:190px;overflow-y:scroll}", ""]);

// exports
